import store from '@/plugins/store'
import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import { LoadQrCommand } from '@/app/settings/commands/load-qr.command'
import { ConfirmTwoFactorCommand } from '@/app/settings/commands/confirm-two-factor.command'
import { DisableTwoFactorCommand } from '@/app/settings/commands/disable-two-factor.command'
import { SendEmailOtpCommand } from '@/app/auth/commands/send-email-otp.command'
import { UpdateConsumerCommand } from '@/app/auth/commands/update-consumer.command'
import { GetTwoFactorAuthStatusCommand } from '@/app/settings/commands/get-twofactor-auth-status.command'

const httpClient = new AxiosClient()

export const loadQrCommand = new LoadQrCommand(httpClient, store)
export const confirmTwoFactorCommand = new ConfirmTwoFactorCommand(httpClient, store)
export const disableTwoFactorCommand = new DisableTwoFactorCommand(httpClient, store)
export const sendEmailOtpCommand = new SendEmailOtpCommand(httpClient, store)
export const updateConsumerCommand = new UpdateConsumerCommand(httpClient, store)
export const getTwoFactorAuthStatusCommand = new GetTwoFactorAuthStatusCommand(httpClient, store)